<template>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
</template>

<script>
export default {
    // 总条目数
    props: ["total"],
    data() {
        return {
            page: {
                // 当前
                page: 1,
                // 每页显示条目个数
                pageSize: 20,
            },
        };
    },
    methods: {
        handleCurrentChange(val) {
            this.page.page = val;
            this.$emit("pagination", this.page);
        },
        handleSizeChange(val) {
            this.page.pageSize = val;
            this.$emit("pagination", this.page);
        },
    },
};
</script>

<style>
</style>